<template>
    <v-card color="grey darken-2"
            height="325"
            :style="activeModel ? 'border-left: 5px solid #070' : 'border-left: 5px solid grey'">

        <v-card-text>
            <validation-observer ref="activityFilterObserver" v-slot="{ invalid }">

                <v-switch
                    class="mt-0 pt-0"
                    v-model="activeModel"
                    label="Enable"
                    color="primary"
                    @change="toggled"
                ></v-switch>

                <v-select
                    v-model="operationModel"
                    :items="booleanOperations"
                    label="Condition"
                    @change="validate"
                ></v-select>

                <div class="pt-0 pb-2 caption">
                    Status
                </div>

                <project-status-selector v-model="statusesModel" @input="validate"></project-status-selector>

                <validation-provider
                    name="Number of days"
                    rules="required|integer|min_value:1|max_value:365"
                    v-slot="{ errors }">

                    <v-text-field
                        v-model="daysModel"
                        class="mt-5"
                        label="In the past"
                        placeholder="Enter # of days"
                        persistent-hint
                        hint="days"
                        :error-messages="errors"
                        @change="validate"
                    ></v-text-field>

                </validation-provider>
            </validation-observer>
        </v-card-text>

    </v-card>

</template>

<script>

import ProjectStatusSelector from "./ProjectStatusSelector";

export default {

    components: {
        ProjectStatusSelector
    },

    props: {
        active: {
            type: Boolean,
            required: true,
            default: false,
        },
        operation: {
            type: String,
            required: true,
        },
        statuses: {
            type: Array,
            required: true,
        },
        days: {
            type: Number,
            required: true,
            default: 31
        }
    },

    data() {
        return {

            activeModel: null,
            operationModel: null,
            statusesModel: [],
            daysModel: null,

            errorMessage: null,
            booleanOperations: [
                {text: 'Include any panelists who have', value: 'must'},
                {text: 'Exclude any panelists who have', value: 'must_not'}
            ],
        }
    },

    mounted() {
        this.activeModel = this.active;
        this.operationModel = this.operation;
        this.statusesModel = this.statuses;
        this.daysModel = this.days;
    },

    methods: {

        validate() {
            if (!this.$refs.activityFilterObserver) return;

            this.$refs.activityFilterObserver.validate()
                .then(isValid => {

                    if (isValid) {

                        this.$emit('change', {
                            active: this.activeModel,
                            excludeOperation: this.operationModel,
                            excludeStatuses: this.statusesModel,
                            excludeDays: parseInt(this.daysModel)
                        })
                    } else {

                        this.activeModel = false;

                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: 'Check activity filter configuration',
                            location: 'bottom'
                        });
                    }
                });
        },

        toggled(enabled) {
            this.validate();
        }
    }
}
</script>
